import React, { useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import VectorLoader from './VectorLoader';
import useMediaQuery from 'hooks/useMediaQuery';
import { useTheme } from 'hooks/useTheme';

gsap.registerPlugin(ScrollTrigger);

const FullPageCard = ({
  imageSrc,
  number,
  title,
  description,
  imageAlt = 'full-page-image',
}) => {
  const cardRef = useRef(null);
  const isMobileSize = useMediaQuery();
  const { isDarkMode } = useTheme();
  useGSAP(
    () => {
      const loadingBar = cardRef.current.querySelector('.loading-bar');
      if (!loadingBar) return;

      ScrollTrigger.create({
        trigger: document.body,
        start: 0,
        end: ScrollTrigger.maxScroll(window),
        onUpdate: (self) => {
          loadingBar.style.width = `${self.progress * 100}%`;
        },
      });

      ScrollTrigger.refresh();
    },
    { scope: cardRef }
  );

  return (
    <div ref={cardRef} className='flex flex-column full-page-card'>
      <img src={imageSrc} alt={imageAlt} className='full-height' />
      <div
        className={`flex flex-column ${isDarkMode ? '' : 'dark-menu-section'}`}
      >
        <div className='flex flex-column flex-1 row-gap-42 justify-end fp-card-header'>
          <span className='font-size-32 font-secondary'>{number}</span>
          {isMobileSize && (
            <span className='font-primary font-size-32'>{title}</span>
          )}
          <VectorLoader progress={0} />
        </div>
        <div className='flex-1 flex justify-between full-page-card-content'>
          {!isMobileSize && (
            <span className='font-primary font-size-32'>{title}</span>
          )}
          <p
            className='text-l-book'
            style={{ width: isMobileSize ? '100%' : '29.82%' }}
          >
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default FullPageCard;
